const i18nMessages = {
  en: {
    errors: {
      base: "An error has occurred.",
    },
    modals: {
      participant: {
        title: "Participant",
        form: {
          firstname: "Firstname",
          lastname: "Lastname",
          email: "E-mail address",
          address: "Postal address",
        },
        submit: "Submit",
      },
    },
    common: {
      search: 'Search...',
      loading: 'Loading...',
      yes: 'Yes',
      no: 'No',
    },
    home: {
      backToPlacesChoice: 'Go back to places list',
      workshops: {
        title: "Online Masterclasses",
        alerts: {
          noWorkshop: "No available workshop for instant.",
          noAvailableWorkshop:
            "You already are participating to all existing workshops.",
        },
      },
      userWorkshops: {
        title: "Already participating",
        noWorkshop: "No participation for instant.",
      },
    },
    workshops: {
      lastSeats: "Almost complete",
      seats: "Complete | 1 slot | {count} seats",
      freeSeats: "No available slot | 1 available slot | {count} available seats",
      free: "Free",
      actions: {
        register: "Register",
        cancel: "Cancel",
        cancelConfirmation: "Are you sure about registering?",
      },
      notifications: {
        registered: {
          title: "Done!",
          message: "You registration is complete.",
        },
        unregistered: {
          title: "Done!",
          message: "You registration has been canceled.",
        },
      },
      errors: {
        workshop_full: "This event is full!",
        already_registered: "You already are registered!",
      },
    },
    placesChoice: {
      title: 'Place choice',
      search: {
        noPlace: 'No place for this search.'
      },
    },
  },
  nl: {
    errors: {
      base: "Er is een fout opgetreden.",
    },
    modals: {
      participant: {
        title: "Deelnemer",
        form: {
          firstname: "Voornaam",
          lastname: "Achternaam",
          email: "E-mailadres",
          address: "Postadres",
        },
        submit: "Indienen",
      },
    },
    home: {
      workshops: {
        title: "Online Masterclasses",
        alerts: {
          noWorkshop: "Momenteel geen beschikbare masterclasses.",
          noAvailableWorkshop: "Je neemt al deel aan alle bestaande workshops.",
        },
      },
      userWorkshops: {
        title: "Doet al mee",
      },
    },
    workshops: {
      freeSeats: "Geen plaats beschikbaar | 1 plaats beschikbaar | {count} plaatsen beschikbaar",
      lastSeats: "Beperkte plekken, wees er snel bij!",
      seats: "Volgeboekt | 1 plaatsen | {count} plaatsen",
      free: "Gratis",
      actions: {
        register: "Inschrijven",
      },
      notifications: {
        registered: {
          title: "Gedaan!",
          message: "Uw registratie is voltooid.",
        },
        unregistered: {
          title: "Beëindigd!",
          message: "Er is rekening gehouden met uw uitschrijving.",
        },
      },
      errors: {
        workshop_full: "Dit evenement zit vol!",
        already_registered: "Je bent al ingeschreven!",
      },
    },
  },
  nl_NL: {
    errors: {
      base: "Er is een fout opgetreden.",
    },
    modals: {
      participant: {
        title: "Deelnemer",
        form: {
          firstname: "Voornaam",
          lastname: "Achternaam",
          email: "E-mailadres",
          address: "Postadres",
        },
        submit: "Indienen",
      },
    },
    home: {
      workshops: {
        title: "Online Masterclasses",
        alerts: {
          noWorkshop: "",
          noAvailableWorkshop: "Je neemt al deel aan alle bestaande workshops.",
        },
      },
      userWorkshops: {
        title: "Doet al mee",
      },
    },
    workshops: {
      freeSeats: "Geen plaats beschikbaar | 1 plaats beschikbaar | {count} plaatsen beschikbaar",
      lastSeats: "Beperkte plekken, wees er snel bij!",
      seats: "Volgeboekt | 1 plaatsen | {count} plaatsen",
      free: "Gratis",
      actions: {
        register: "Inschrijven",
      },
      notifications: {
        registered: {
          title: "Gedaan!",
          message: "Uw registratie is voltooid.",
        },
        unregistered: {
          title: "Beëindigd!",
          message: "Er is rekening gehouden met uw uitschrijving.",
        },
      },
      errors: {
        workshop_full: "Dit evenement zit vol!",
        already_registered: "Je bent al ingeschreven!",
      },
    },
  },
  nl_BE: {
    errors: {
      base: "Er is een fout opgetreden.",
    },
    modals: {
      participant: {
        title: "Deelnemer",
        form: {
          firstname: "Voornaam",
          lastname: "Achternaam",
          email: "E-mailadres",
          address: "Postadres",
        },
        submit: "Indienen",
      },
    },
    home: {
      workshops: {
        title: "Online Masterclasses",
        alerts: {
          noWorkshop: "Momenteel geen beschikbare masterclasses.",
          noAvailableWorkshop: "Je neemt al deel aan alle bestaande workshops.",
        },
      },
      userWorkshops: {
        title: "Doet al mee",
      },
    },
    workshops: {
      freeSeats: "Geen plaats beschikbaar | 1 plaats beschikbaar | {count} plaatsen beschikbaar",
      lastSeats: "Beperkte plekken, wees er snel bij!",
      seats: "Volgeboekt | 1 plaatsen | {count} plaatsen",
      free: "Gratis",
      actions: {
        register: "Inschrijven",
      },
      notifications: {
        registered: {
          title: "Gedaan!",
          message: "Uw registratie is voltooid.",
        },
        unregistered: {
          title: "Beëindigd!",
          message: "Er is rekening gehouden met uw uitschrijving.",
        },
      },
      errors: {
        workshop_full: "Dit evenement zit vol!",
        already_registered: "Je bent al ingeschreven!",
      },
    },
  },
  cs: {
    errors: {
      base: "Došlo k chybě.",
    },
    modals: {
      participant: {
        title: "Účastník",
        form: {
          firstname: "Jméno",
          lastname: "Příjmení",
          email: "Emailová adresa",
          address: "Poštovní adresa",
        },
        submit: "Předložit",
      },
    },
    home: {
      workshops: {
        title: "Online mistrovské kurzy",
        alerts: {
          noWorkshop: "Okamžitě žádná dostupná dílna.",
          noAvailableWorkshop: "Již se účastníte všech existujících workshopů.",
        },
      },
      userWorkshops: {
        title: "Již se účastní",
      },
    },
    workshops: {
      lastSeats: "Téměř kompletní",
      seats: "Kompletní | 1 slot | {count} slotů",
      free: "Volný, uvolnit",
      actions: {
        register: "Registrovat",
      },
      notifications: {
        registered: {
          title: "Hotovo!",
          message: "Vaše registrace je dokončena.",
        },
      },
      errors: {
        workshop_full: "Tato akce je plná!",
        already_registered: "Již jste registrováni!",
      },
    },
  },
  fr: {
    errors: {
      base: "Une erreur est survenue.",
    },
    modals: {
      participant: {
        title: "Participant",
        form: {
          firstname: "Prénom",
          lastname: "Nom de famille",
          email: "Adresse e-mail",
          address: "Adresse postale",
          phone: "Téléphone",
          loyalty_card_number: "Numéro de carte de fidélité",
        },
        submit: "Soumettre",
      },
    },
    common: {
      search: 'Rechercher...',
      loading: 'Chargement...',
      yes: 'Oui',
      no: 'Non',
    },
    home: {
      backToPlacesChoice: 'Retour à la liste des lieux',
      workshops: {
        title: "Masterclasses en ligne",
        alerts: {
          noWorkshop: "Aucun atelier disponible pour l'instant.",
          noAvailableWorkshop:
            "Vous participez déjà à tous les ateliers existants.",
        },
      },
      userWorkshops: {
        title: "Déjà participant",
        noWorkshop: "Aucune inscription pour le moment.",
      },
    },
    workshops: {
      lastSeats: "Presque complet",
      seats: "Complet | 1 place | {count} places",
      freeSeats: "Pas de place disponible | 1 place disponible | {count} places disponibles",
      free: "Gratuit",
      actions: {
        register: "S'inscrire",
        cancel: "Se désinscrire",
        cancelConfirmation: "Etes-vous sûr(e) de vouloir vous désinscrire ?",
      },
      notifications: {
        registered: {
          title: "Terminé !",
          message: "Votre inscription est terminée.",
        },
        unregistered: {
          title: "Terminé !",
          message: "Votre désinscription a été prise en compte.",
        },
      },
      errors: {
        workshop_full: "Cet événement est complet !",
        already_registered: "Vous êtes déjà inscrit(e) !",
      },
    },
    placesChoice: {
      title: 'Choix du lieu',
      search: {
        noPlace: 'Aucun lieu ne correspond à cette recherche.'
      },
    },
  },
  de: {
    errors: {
      base: "Ein Fehler ist aufgetreten.",
    },
    modals: {
      participant: {
        title: "Teilnehmer",
        form: {
          firstname: "Vorname",
          lastname: "Nachname",
          email: "E-Mail-Addresse",
          address: "Anschrift",
        },
        submit: "einreichen",
      },
    },
    home: {
      workshops: {
        title: "Online-Meisterkurse",
        alerts: {
          noWorkshop: "Momentan keine verfügbare Werkstatt.",
          noAvailableWorkshop:
            "Sie nehmen bereits an allen bestehenden Workshops teil.",
        },
      },
      userWorkshops: {
        title: "Schon mitmachen",
      },
    },
    workshops: {
      lastSeats: "Fast fertig",
      seats: "Vollständig | 1 Steckplatz | {count} Slots",
      free: "Kostenlos",
      actions: {
        register: "Registrieren",
      },
      notifications: {
        registered: {
          title: "Fertig!",
          message: "Ihre Registrierung ist abgeschlossen.",
        },
      },
      errors: {
        workshop_full: "Diese Veranstaltung ist voll!",
        already_registered: "Sie sind bereits registriert!",
      },
    },
  },
  hu: {
    errors: {
      base: "Hiba történt.",
    },
    modals: {
      participant: {
        title: "Résztvevő",
        form: {
          firstname: "Keresztnév",
          lastname: "Vezetéknév",
          email: "Email cím",
          address: "Postázási cím",
        },
        submit: "Beküldés",
      },
    },
    home: {
      workshops: {
        title: "Online mesterkurzusok",
        alerts: {
          noWorkshop: "Azonnal nincs elérhető műhely.",
          noAvailableWorkshop: "Már részt vesz az összes meglévő workshopon.",
        },
      },
      userWorkshops: {
        title: "Már részt vesz",
      },
    },
    workshops: {
      lastSeats: "Majdnem kész",
      seats: "Teljes | 1 nyílás | {count} hely",
      free: "Ingyenes",
      actions: {
        register: "Regisztráció",
      },
      notifications: {
        registered: {
          title: "Kész!",
          message: "A regisztrációd kész.",
        },
      },
      errors: {
        workshop_full: "Ez az esemény megtelt!",
        already_registered: "Már regisztráltál!",
      },
    },
  },
  it: {
    errors: {
      base: "C'è stato un errore.",
    },
    modals: {
      participant: {
        title: "Partecipante",
        form: {
          firstname: "Nome di battesimo",
          lastname: "Cognome",
          email: "Indirizzo email",
          address: "Indirizzo postale",
        },
        submit: "Invia",
      },
    },
    home: {
      workshops: {
        title: "Masterclass in linea",
        alerts: {
          noWorkshop: "Nessun workshop disponibile per l'istante.",
          noAvailableWorkshop:
            "Stai già partecipando a tutti i workshop esistenti.",
        },
      },
      userWorkshops: {
        title: "Già partecipando",
      },
    },
    workshops: {
      lastSeats: "Quasi completo",
      seats: "Completare | 1 posto | {count} slot",
      free: "Libero",
      actions: {
        register: "Registrati",
      },
      notifications: {
        registered: {
          title: "Fatto!",
          message: "La tua registrazione è completa.",
        },
      },
      errors: {
        workshop_full: "Questo evento è pieno!",
        already_registered: "Sei già registrato!",
      },
    },
  },
  sk: {
    errors: {
      base: "Došlo k chybe.",
    },
    modals: {
      participant: {
        title: "Účastník",
        form: {
          firstname: "Krstné meno",
          lastname: "Priezvisko",
          email: "Emailová adresa",
          address: "Postadress",
        },
        submit: "Predložiť",
      },
    },
    home: {
      workshops: {
        title: "Online majstrovské kurzy",
        alerts: {
          noWorkshop: "Okamžite žiadna dostupná dielňa.",
          noAvailableWorkshop:
            "Už sa zúčastňujete všetkých existujúcich workshopov.",
        },
      },
      userWorkshops: {
        title: "Už sa zúčastňujem",
      },
    },
    workshops: {
      lastSeats: "Takmer kompletné",
      seats: "Dokončiť | 1 slot | {count} slotov",
      free: "zadarmo",
      actions: {
        register: "Registrovať",
      },
      notifications: {
        registered: {
          title: "Hotový!",
          message: "Vaša registrácia je dokončená.",
        },
      },
      errors: {
        workshop_full: "Toto podujatie je plné!",
        already_registered: "Už ste zaregistrovaný!",
      },
    },
  },
  pt: {
    errors: {
      base: "Ocorreu um erro.",
    },
    modals: {
      participant: {
        title: "Participante",
        form: {
          firstname: "Primeiro nome",
          lastname: "Último nome",
          email: "Endereço de e-mail",
          address: "Endereço postal",
        },
        submit: "Enviar",
      },
    },
    home: {
      workshops: {
        title: "Masterclasses online",
        alerts: {
          noWorkshop: "Nenhuma oficina disponível para o instante.",
          noAvailableWorkshop:
            "Você já está participando de todos os workshops existentes.",
        },
      },
      userWorkshops: {
        title: "Já participando",
      },
    },
    workshops: {
      lastSeats: "Quase completo",
      seats: "Completo | 1 vaga | {count} slots",
      free: "Livre",
      actions: {
        register: "Registro",
      },
      notifications: {
        registered: {
          title: "Feito!",
          message: "Seu cadastro está completo.",
        },
      },
      errors: {
        workshop_full: "Este evento está cheio!",
        already_registered: "Você já está cadastrado!",
      },
    },
  },
  es: {
    errors: {
      base: "Se ha producido un error.",
    },
    modals: {
      participant: {
        title: "Partícipe",
        form: {
          firstname: "Nombre de pila",
          lastname: "Apellido",
          email: "Dirección de correo electrónico",
          address: "Direccion postal",
        },
        submit: "Entregar",
      },
    },
    home: {
      workshops: {
        title: "Clases magistrales en línea",
        alerts: {
          noWorkshop: "No hay taller disponible para el instante.",
          noAvailableWorkshop:
            "Ya estás participando en todos los talleres existentes.",
        },
      },
      userWorkshops: {
        title: "Ya participando",
      },
    },
    workshops: {
      lastSeats: "Casi completo",
      seats: "Completo | 1 ranura | {contar} ranuras",
      free: "Gratis",
      actions: {
        register: "Registrarse",
      },
      notifications: {
        registered: {
          title: "¡Hecho!",
          message: "Su registro está completo.",
        },
      },
      errors: {
        workshop_full: "¡Este evento está lleno!",
        already_registered: "¡Ya estás registrado!",
      },
    },
  },
  ro: {
    errors: {
      base: "A avut loc o eroare.",
    },
    modals: {
      participant: {
        title: "Participant",
        form: {
          firstname: "Nume",
          lastname: "Numele de familie",
          email: "Adresa de email",
          address: "Adresa postala",
        },
        submit: "Trimite",
      },
    },
    home: {
      workshops: {
        title: "Masterclassuri online",
        alerts: {
          noWorkshop: "Nici un atelier disponibil pentru moment.",
          noAvailableWorkshop:
            "Deja participați la toate atelierele existente.",
        },
      },
      userWorkshops: {
        title: "Deja participă",
      },
    },
    workshops: {
      lastSeats: "Aproape complet",
      seats: "Complet | 1 slot | {count} sloturi",
      free: "Gratuit",
      actions: {
        register: "Inregistreaza-te",
      },
      notifications: {
        registered: {
          title: "Terminat!",
          message: "Înregistrarea dumneavoastră este finalizată.",
        },
      },
      errors: {
        workshop_full: "Acest eveniment este plin!",
        already_registered: "Ești deja înregistrat!",
      },
    },
  },
};

export default i18nMessages
